import React from "react";
import { Moon, Sun } from "lucide-react";
import { Switch } from "./switch";
import { useTheme } from "../../context/ThemeContext";
import { Button } from "./button";

export function ThemeToggle({ compact = false }) {
  const { isDark, toggleTheme } = useTheme();

  if (compact) {
    // Icon-only variant: click to toggle between sun and moon
    return (
      <Button
        variant="ghost"
        size="icon"
        aria-label={isDark ? "Activer le thème clair" : "Activer le thème sombre"}
        title={isDark ? "Mode clair" : "Mode sombre"}
        onClick={toggleTheme}
        className="text-foreground"
      >
        {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </Button>
    );
  }

  return (
    <div className="flex items-center space-x-2">
      <Sun className="h-4 w-4 text-yellow-500" />
      <Switch
        checked={isDark}
        onCheckedChange={toggleTheme}
        className=""
      />
      <Moon className="h-4 w-4 text-blue-500" />
    </div>
  );
} 